/**
 * ScrapInstructionsDialog - Dialog com instruções de uso do ScrapAudience
 *
 * Exibe passo a passo de como usar o ScrapAudience para coletar dados de audiência.
 */
import React from 'react';
import {
  Button,
  Alert,
  Typography,
  Box,
  DialogContent,
  DialogActions
} from '@mui/material';
import { Psychology as PsychologyIcon } from '@mui/icons-material';
import PlatformDialog from '../../../molecules/PlatformDialog/PlatformDialog';
import PlatformDialogTitle from '../../../molecules/PlatformDialog/PlatformDialogTitle';

const ScrapInstructionsDialog = ({ open, onClose }) => {

  return (
    <PlatformDialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
    >
      <PlatformDialogTitle 
        title="Próximos Passos - ScrapAudience"
        subtitle="Siga as instruções para coletar dados de audiência."
        icon={<PsychologyIcon />}
        onClose={onClose}
      />
      <DialogContent sx={{ pt: 3, pb: 2 }}>
        <Alert severity="success" variant="filled" sx={{ mb: 3, borderRadius: 2 }}>
          Arquivo JSON exportado com sucesso! Agora siga o fluxo abaixo:
        </Alert>

        <Typography variant="subtitle1" gutterBottom fontWeight={700}>
          📋 Fluxo de Trabalho ScrapAudience:
        </Typography>

        <Box component="ol" sx={{ pl: 2, '& li': { mb: 2 } }}>
          <Typography component="li" variant="body2">
            <strong>Abra o Terminal e Inicie o ScrapAudience:</strong>
            <Box
              component="pre"
              sx={{
                bgcolor: 'action.hover',
                p: 2,
                borderRadius: 2,
                mt: 1,
                fontFamily: 'monospace',
                fontSize: '0.8rem',
                border: '1px solid',
                borderColor: 'divider'
              }}
            >
              cd ScrapAudience{'\n'}
              python gui.py
            </Box>
          </Typography>

          <Typography component="li" variant="body2">
            <strong>Login no SimilarWeb:</strong> Clique em "Login com Google" e realize o login manual na sua conta SimilarWeb Pro. Aguarde a confirmação do browser interno.
          </Typography>

          <Typography component="li" variant="body2">
            <strong>Importação:</strong> No ScrapAudience, clique em "🔽 Exportar do Mensure Monitor" e selecione o arquivo que você acabou de baixar.
          </Typography>

          <Typography component="li" variant="body2">
            <strong>Coleta:</strong> Clique em "Iniciar Scraping" e aguarde. O processo pode levar alguns minutos dependendo da quantidade de domínios.
          </Typography>

          <Typography component="li" variant="body2">
            <strong>Sincronização:</strong> Volte ao Mensure Monitor e clique em "🔼 Importar do ScrapAudience" para processar os resultados coletados.
          </Typography>
        </Box>

        <Alert severity="warning" variant="outlined" sx={{ mt: 3, borderRadius: 2 }}>
          <Typography variant="caption" display="block">
            <strong>Nota Técnica:</strong> O login manual é obrigatório pois o SimilarWeb não disponibiliza API pública para este tipo de extrator.
          </Typography>
        </Alert>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 3 }}>
        <Button 
          onClick={onClose} 
          variant="contained"
          sx={{ fontWeight: 700, borderRadius: 2, px: 4 }}
        >
          Entendi, vamos lá!
        </Button>
      </DialogActions>
    </PlatformDialog>
  );
};

export default ScrapInstructionsDialog;
